import { Paper, Text } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/hub/tax-documents")({
  component: TaxDocuments,
})

function TaxDocuments() {
  return (
    <Paper withBorder p="lg" radius={0} style={{ borderColor: "var(--pitch-border)" }}>
      <Text c="var(--pitch-text-tertiary)">
        Tax document center — K-1s, QSBS certificates, and basis statements will appear here after tax year close.
      </Text>
    </Paper>
  )
}
